import {BasePopupProps} from "../../Models";
import FlintTextArea from "../../../components/controls/FlintTextArea";
import {useState} from "react";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "../../../components/controls/FlintButton";
import {useTranslation} from "react-i18next";
import {Error} from "@progress/kendo-react-labels";
import {Calendar} from "@progress/kendo-react-dateinputs";
import {useVivoPopupContext} from "@utils/popups/VivoPopupContext";

export default function CalendarSelectionDialog(props: CalendarSelectionDialogProps) {
    const {state, handlers} = useCalendarSelectionDialogDialog(props);
    const {t} = useTranslation();
    return <div className={"text-area-popup text-center"}>
        {props.description &&
            <div className={"my-2"} dangerouslySetInnerHTML={{__html: props.description}}/>}
        <div className={"form-group mb-4"}>
            <Calendar value={state.selectedDate.get} onChange={x => {
                state.selectedDate.set(x.value)
            }}/>
        </div>
        <WindowActionsBar layout={"stretched"}>
            <FlintButton themeColor={"secondary"}
                         onClick={handlers.handleCancelled}>{t("Cancel")}</FlintButton>
            <FlintButton themeColor={"primary"}
                         onClick={handlers.handleConfirmed}>{t("Confirm")}</FlintButton>
        </WindowActionsBar>
    </div>
}

export interface CalendarSelectionDialogProps extends BasePopupProps<Date> {
    description?: string;
}


function useCalendarSelectionDialogDialog(props: CalendarSelectionDialogProps) {
    const [selectedDate, setSelectedDate] = useState<Date>();
    const {t} = useTranslation();
    function handleCancelled() {
        props.OnCancelled();
    }

    function handleConfirmed() {
        if (!selectedDate) {
            alert(t("COMMON_SelectDate"));
            return;
        }
        props.OnConfirmedAndSaved(selectedDate);
    }


    return {
        state: {
            selectedDate: {get: selectedDate, set: setSelectedDate},
        },
        handlers: {
            handleConfirmed,
            handleCancelled,
        }
    }
}